<div style="width: 100%; height: 100%" #chartView></div>
